import { types, Instance, applySnapshot, applyPatch, onSnapshot, onPatch, SnapshotIn, IJsonPatch, getSnapshot } from 'mobx-state-tree';
import { appLocalStore } from './appLocalStore';

const UserModelBase = types.model('User', {
  id: types.identifier,
  name: types.string,
  avatar: types.union(types.string, types.null),
  isTestUser: types.optional(types.boolean, false),
}).views((self) => ({
  get isHost() : boolean {
    return appSyncStore.hostId === self.id;
  }
}));

const UserModel = types.snapshotProcessor(UserModelBase, {
  // Remove the profile picture from snapshots to reduce size
  // But keep avatars for test users since they won't be synced separately
  postProcessor(snapshot) {
    console.warn('TODO-This is being called on participant peers too');
    if (snapshot.isTestUser) {
      // Keep avatar for test users
      return snapshot;
    }
    return {
      ...snapshot,
      avatar: null,
    }
  },
});

export interface User extends Instance<typeof UserModel> { }

// Just in case, to prevent applying patches before snapshot
let _snapshotReceived = false;

export const AppSyncModel = types
  .model('AppSync', {

    users: types.map(UserModel),
    hostId: types.maybeNull(types.string),
    gameId: types.maybeNull(types.string),
    gameActive: types.optional(types.boolean, false),
    testMode: types.optional(types.boolean, false),

  })
  .views((self) => ({
    get canStartGame() {
        return self.testMode || (appLocalStore.isHost && self.users.size >= 2);
    }
  }))
  .actions((self) => ({

    action(callback: (s: typeof self )=>void) {
      callback(self);
    },

    applyUserAvatar(id: number, avatar: string | null) {
      const user = self.users.get(id.toString());
      if (user) {
        user.avatar = avatar;
      } else {
        console.error(`User with id ${id} not found to apply avatar`);
    }
    },

    removeUser(id: string) {
      self.users.delete(id);
    },

    upsertUser(user: SnapshotIn<typeof UserModel>) {
      self.users.set(user.id, user);
    },

    // *****************************
    // Snapshot and Patch Management
    // *****************************

    getSnapshotWithoutAvatars() {
      return getSnapshot(self);
    },

    applySnapshot(snapshot: SnapshotIn<typeof AppSyncModel>) {
      _snapshotReceived = true;
      applySnapshot(self, snapshot);
    },

    registerPatchListener(onPatchChange: (patch: IJsonPatch, reversePatch: IJsonPatch) => void) {
      return onPatch(self, onPatchChange);
    },

    applyPatch(patch: IJsonPatch) {
      if (!_snapshotReceived) {
        console.error('Snapshot not received yet, skipping patch application');
        return;
      }
      applyPatch(self, patch);
    },

  }));


export const appSyncStore = AppSyncModel.create({
    users: {},
    hostId: null,
    gameId: null
});
